import { useTheme } from '@mui/material';
import {
	CartesianGrid,
	Line,
	LineChart as RechartsLineChart,
	ReferenceLine,
	ResponsiveContainer,
	Tooltip as GraphTooltip,
	XAxis,
	YAxis,
} from 'recharts';

import useFormat from '../../../../../hooks/useFormat';
import { currencyFormatter, N_MINUS_1_COLOR, N_COLOR, tickFormatter } from '../utils/chart';

type dataType = {
	name: string;
	previousValue: number;
	value: number;
};

const LineChart = ({ data, labelFormatter }: { data: dataType[]; labelFormatter: (label: string) => string }) => {
	const { shape, shadows } = useTheme();
	const { isMobileFormat } = useFormat();

	return (
		<ResponsiveContainer width="100%" height="100%">
			<RechartsLineChart
				data={data}
				margin={
					!isMobileFormat
						? {
								top: 32,
								left: -16,
						  }
						: { right: 8, left: 8 }
				}
			>
				<CartesianGrid strokeDasharray={isMobileFormat ? '0' : '3 3'} vertical={!isMobileFormat} />
				<XAxis dataKey="name" height={20} />
				{!isMobileFormat && <YAxis width={80} tickFormatter={tickFormatter} />}
				<ReferenceLine y={0} stroke="#000" />
				<GraphTooltip
					formatter={currencyFormatter}
					labelFormatter={labelFormatter}
					contentStyle={{ borderRadius: shape.borderRadius, boxShadow: shadows[1] }}
				/>
				<Line dataKey="previousValue" name="N-1" fill={N_MINUS_1_COLOR} stroke={N_MINUS_1_COLOR} />
				<Line type="monotone" dataKey="value" name="N" fill={N_COLOR} stroke={N_COLOR} />
			</RechartsLineChart>
		</ResponsiveContainer>
	);
};

export default LineChart;
